import React from 'react';

/**
 * @typedef {object} AggregatePerformanceTooltipData
 * @property {string} quarter
 * @property {number} [average]
 * @property {number} [median]
 * @property {number} [count]
 */

/**
 * @typedef {object} AggregatePerformanceTooltipProps
 * @property {AggregatePerformanceTooltipData} [data]
 */

/**
 * @param {AggregatePerformanceTooltipProps} props
 */
const AggregatePerformanceTooltip = props => {
  const { data } = props;

  return (
    <div className='tooltip' data-testid='aggregate-chart-tooltip'>
      <b>{data.quarter}</b>
      <div>Count of Reports: {data.count}</div>
      <div>Metric aggregate (Average): {data.average}</div>
      <div>Metric aggregate (Median): {data.median}</div>
    </div>
  );
};

export default AggregatePerformanceTooltip;
